import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Helmet from "react-helmet"
import Header from '../components/Header'
import Banner from '../components/Banner'
import Overview from '../components/Overview'
import Paper from '../components/Paper'
import Important from '../components/Important'
import Call from '../components/Call'
import Competition from '../components/Competition'
import Invited from '../components/Invited'
import Schedule from '../components/Schedule'
import Posters from '../components/Posters'
import Organizers from '../components/Organizers'
import Program from '../components/Program'
import Previous from '../components/Previous'
import Contact from '../components/Contact'
import 'antd/dist/antd.css';
import './style.scss'

export default function Home({ description, lang, meta,keywords, title, tags }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  const metaDescription = description || site.siteMetadata.description
  const metaKeywords =  site.siteMetadata.keywords
  return <div className="page-box">
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      tags={tags}
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: metaKeywords
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
      ].concat(meta)}
      link={[{rel:"icon",href:""}]}           // favicon
    />
    <Header />
    <Banner />
    <Overview />
    <Paper />
    <Important />
    <Call />
    <Competition />
    <Invited />
    <Schedule />
    <Posters />
    <Organizers />
    <Program />
    <Previous />
    <Contact />
  </div>
}

Home.defaultProps = {
  lang: `zh-CN`,
  meta: [],
  description: `Workshop at CVPR 2021`,
  title:`Adversarial Machine Learning in Real-World Computer Vision Systems and Online Challenges (AML-CV) | Workshop at CVPR 2021`
}

Home.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

